import * as defaultImport from "@splunk/react-icons/ArrowBroadUnderbarDown";
export * from "@splunk/react-icons/ArrowBroadUnderbarDown";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
